import type { NameSortation } from 'common/enum/user.setting.enum';

export const studentKeys = {
  all: ['students'],

  lists: () => [...studentKeys.all, 'list'],

  classList: (schoolClassId: number | null | undefined, nameSortation: NameSortation) => [
    ...studentKeys.lists(),
    'class',
    schoolClassId ?? null,
    nameSortation,
  ],

  schoolList: (tenantId: number | null | undefined, nameSortation: NameSortation, hasAdminAccess: boolean) => [
    ...studentKeys.lists(),
    'admin',
    tenantId ?? null,
    nameSortation,
    hasAdminAccess,
  ],

  selectableLists: () => [...studentKeys.lists(), 'selectable'],

  selectableList: (params: {
    schoolClassId?: number | null;
    nameSortation: NameSortation;
    canSelectStudents: boolean;
  }) => [
    ...studentKeys.selectableLists(),
    params.schoolClassId ?? null,
    params.nameSortation,
    params.canSelectStudents,
  ],
};
